var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7482,
    cy: 14,
    r: 13.6384,
    fill: "#3063E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7483 9.58639C15.53 9.58639 16.9746 11.03 16.9746 12.8114C16.9746 14.1957 16.1019 15.3763 14.8768 15.8338C14.7943 15.8646 14.8061 16.0366 14.8928 16.0515C16.3341 16.2982 17.6192 17.0024 18.5932 18.0093C18.8385 18.2628 19.2468 18.2968 19.4845 18.0362C20.7413 16.6573 21.5076 14.824 21.5076 12.8114C21.5076 8.52669 18.0334 5.05292 13.7482 5.05292C9.46286 5.05292 5.98877 8.52669 5.98877 12.8114C5.98877 14.824 6.75511 16.6573 8.01189 18.0361C8.24952 18.2968 8.6579 18.2628 8.90314 18.0092C9.87705 17.0023 11.162 16.2982 12.6033 16.0515C12.6901 16.0366 12.7019 15.8646 12.6194 15.8338C11.3943 15.3762 10.5221 14.1957 10.5221 12.8114C10.5222 11.03 11.9666 9.58639 13.7483 9.58639Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5813 21.5095C16.5813 23.0687 15.2953 24.3327 13.709 24.3327C12.1227 24.3327 10.8367 23.0687 10.8367 21.5095C10.8367 19.9502 12.1227 18.6862 13.709 18.6862C15.2953 18.6862 16.5813 19.9502 16.5813 21.5095Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCircle);
export default __webpack_public_path__ + "static/media/logoCircle.7cc252b93c7ffce0e146ae55b9a9a0fb.svg";
export { ForwardRef as ReactComponent };